export default {
  ImageGrid: () =>
    import(`@soenergy/frontend-library/src/components/ImageGrid`),
  TextBanner: () => import(`./TextBanner`),
  TwoColumnBlock: () =>
    import(`@soenergy/frontend-library/src/components/TwoColumnBlock`),
  TwoColumnBlockStack: () =>
    import(`@soenergy/frontend-library/src/components/TwoColumnBlockStack`),
  TwoColumnHero: () =>
    import(`@soenergy/frontend-library/src/components/TwoColumnHero`),
  TrustpilotCard: () =>
    import(`@soenergy/frontend-library/src/components/TrustpilotCard`),
  JobVacancyCard: () => import(`./JobVacancyCard`),
  ReadMoreCard: () =>
    import(`@soenergy/frontend-library/src/components/ReadMoreCard`),
  Carousel: () => import(`@soenergy/frontend-library/src/components/Carousel`),
  JobVacancyCarousel: () => import(`./JobVacancyCarousel`),
  OurValues: () => import(`./OurValues`),
  EnergyVote: () => import(`./EnergyVote`),
  EnergySourceMix: () => import(`./EnergySourceMix`),
  GreenImpact: () => import("./GreenImpact"),
  Article: () => import("@soenergy/frontend-library/src/components/Article"),
  OrderedList: () =>
    import("@soenergy/frontend-library/src/components/OrderedList"),
  OrderedListItem: () =>
    import("@soenergy/frontend-library/src/components/OrderedListItem"),
  UspBlock: () => import("@soenergy/frontend-library/src/components/UspBlock"),
  UspBlockDetailed: () =>
    import("@soenergy/frontend-library/src/components/UspBlockDetailed"),
  TwoCardBlock: () =>
    import("@soenergy/frontend-library/src/components/TwoCardBlock"),
  IllustratedSteps: () =>
    import("@soenergy/frontend-library/src/components/IllustratedSteps"),
  AppTable: () => import("@soenergy/frontend-library/src/components/AppTable"),
  CustomerReviewBlock: () => import(`./CustomerReviewBlock`),
  GetQuoteHero: () => import("./GetQuoteHero"),
  FullWidthImageGridBlock: () => import(`./FullWidthImageGridBlock`),
  FullWidthImageBlock: () => import(`./FullWidthImageBlock`),
  TwoColumnTextBlock: () =>
    import("@soenergy/frontend-library/src/components/TwoColumnTextBlock"),
  ArticleWithIcon: () => import("./ArticleWithIcon"),
  ContactForm: () => import("./ContactForm"),
  ChartBlock: () => import("./ChartBlock"),
  AccordionBlock: () =>
    import("@soenergy/frontend-library/src/components/AccordionBlock"),
  HeadingBanner: () => import("./HeadingBanner"),
  HeroBannerHomepage: () =>
    import("@soenergy/frontend-library/src/components/HeroBannerHomepage")
}
